import { answerExclusive, createAnswerSchemaWithMixins } from '../answerSchemaFields';
import {
  createQuestionSchemaWithMixins,
  questionAutoNext,
  questionHasComment,
  questionHasGratitude,
  questionHasTimer,
  questionImage,
  questionImageBackground,
  questionImageMap,
  questionInstantStatistic,
  questionRatingHasHints,
  questionRatingMaximum,
  questionRatingMinimum,
  questionRatingSliderLabels,
  questionRatingSliderPreset,
  questionRatingSliderTheme,
  questionRequiresAnswer,
} from '../questionSchemaFields';
import { config } from './RatingSliderPoll.config';

export const schema = createQuestionSchemaWithMixins({
  mixins: {
    questionAutoNext,
    questionHasComment,
    questionHasGratitude,
    questionHasTimer,
    questionImage,
    questionImageBackground,
    questionImageMap,
    questionRatingHasHints,
    questionRatingMaximum,
    questionRatingMinimum,
    questionRatingSliderTheme,
    questionRequiresAnswer,
    questionInstantStatistic,
    questionRatingSliderPreset,
    questionRatingSliderLabels,
  },
  type: config.name,
  answer: createAnswerSchemaWithMixins({
    mixins: { answerExclusive },
  }),
});
